import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { LoaderService } from 'src/modules/shared/services/loader.service';
import { catchError } from 'rxjs/operators';
import { INews } from 'src/modules/shared/interfaces/INews';
import { AnnoncementRequester } from 'src/modules/shared/enums/annoncement-requester.enum';
import { AnnouncementService } from 'src/modules/announcement/_services/announcement.service';
import { TranslateService } from '@ngx-translate/core';
import { NewsManagementService } from 'src/modules/News/_services/news-management.service';


@Injectable({
  providedIn: 'root'
})

export class WhatIsHappendResolver implements Resolve<INews>{

  constructor(private newsService: NewsManagementService, private translateService: TranslateService) {
  }

  resolve(): Observable<INews> {
    LoaderService.showLoader();
    let body = {
      "pageNumber": 1,
      "pageCount": 3,
      // "AnnoncementRequester": AnnoncementRequester.Home,
      // "IsMain": true,
      "HeaderProperties": { "UserLanguage": this.translateService.currentLang == 'ar' ? this.translateService.currentLang + '-SA' : 'en'},
      "OrderedPropeties": [
        {
          "key": "startDate",
          "value": 'Dec'
        }
      ]
    }
    return this.newsService.getNewsList(body).pipe(
      catchError(error => {
        console.log(error)
        LoaderService.hideLoader();
        return of(null);
      })
    );
  }


}
